// Module
var code = `<div class="svd-test-results">
    <div class="svd-test-results__content">
        <div class="svd-test-results__header">
            <div class="svd-test-results__header-text" data-bind="text: surveyResultsText"></div>
            <div class="svd-test-results__header-types">
                <svc-action-button params="text: surveyResultsTableText, click: selectTableClick, disabled: false, selected: isTableSelected">
                </svc-action-button>
                <svc-action-button params="text: surveyResultsJsonText, click: selectJsonClick, disabled: false, selected: isJsonSelected">
                </svc-action-button>
            </div>
        </div>
        <div class="svd-test-results__text svd-light-bg-color" data-bind="visible: resultViewType === 'text'">
            <div data-bind="text: resultText"></div>
        </div>
        <div class="svd-test-results__table svd-light-bg-color" data-bind="visible: resultViewType === 'table'">
            <table>
                <thead>
                    <tr class="svd-light-background-color">
                        <th class="svd-dark-border-color" data-bind="text: resultsTitle"></th>
                        <th class="svd-dark-border-color" data-bind="text: resultsDisplayValue"></th>
                    </tr>
                </thead>
                <tbody>
                    <!-- ko foreach: resultData -->
                    <!-- ko component: { name: 'survey-results-table-row', params: { model: \$data } } -->
                    <!-- /ko -->
                    <!-- /ko -->
                </tbody>
            </table>
        </div>
    </div>
</div>`;
// Exports
export default code;